import { format } from "date-fns";
import { t } from "@/i18n-js/instance";
import { toLocaleString } from "@circle-react/helpers/number";
import { Typography } from "@circle-react-uikit/Typography";

// Cell renderers as functions that return JSX
export const renderWorkflowName = (value: string) => (
  <Typography.BodyMd>{value}</Typography.BodyMd>
);

export const renderCredits = (value: number) => (
  <Typography.BodyMd>{toLocaleString(value)}</Typography.BodyMd>
);

export const renderCharges = (value: number) => (
  <Typography.BodyMd>
    {value > 0 ? `$${value.toFixed(2)}` : "-"}
  </Typography.BodyMd>
);

export const renderTotalRuns = (value: number) => (
  <Typography.BodyMd>{toLocaleString(value)}</Typography.BodyMd>
);

export const renderCreatedAt = (value: string) => {
  const date = new Date(value);
  return (
    <Typography.BodyMd>
      {format(date, t("settings.billing.ai_actions.date_format"))}
    </Typography.BodyMd>
  );
};
